'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var select = require('pkg/select/select');
exports.default = select;